import { render, staticRenderFns } from "./ModalBankingData.vue?vue&type=template&id=4ec5b7eb&scoped=true&"
import script from "./ModalBankingData.vue?vue&type=script&lang=js&"
export * from "./ModalBankingData.vue?vue&type=script&lang=js&"
import style0 from "./ModalBankingData.vue?vue&type=style&index=0&id=4ec5b7eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5b7eb",
  null
  
)

export default component.exports